






import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class ErrorGroup extends Vue {
  @Prop()
  protected field?: string;
  @Prop()
  protected error?: any;
  @Prop()
  protected fieldState?: any;
}
